import { createReducer, on, Action } from '@ngrx/store';
import * as transportSitesActions from '../actions/transport-sites.actions';
import { TransportSitesResponseModel } from 'app/models/transport-sites.model';

export interface State {
  transportSites: TransportSitesResponseModel;
  isLoading: boolean;
  isReady: boolean;
}

export const initialState: State = {
  transportSites: { results: [], count: 0 },
  isLoading: false,
  isReady: false,
};

export const featureReducer = createReducer(
  initialState,
  on(transportSitesActions.loadTransportSites, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(
    transportSitesActions.loadTransportSitesSuccess,
    (state: State, { response }) => ({
      ...state,
      isLoading: false,
      isReady: true,
      transportSites: response,
    })
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
